import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { ToastOptions } from '@ionic/core';
import { Constants } from 'uApp/app.constants';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public toastDuration = 0;

  constructor(public toastCtrl: ToastController) { }

  public showToast(options: ToastOptions): void {
    let duration = this.toastDuration;
    if (duration === 0) {
      // const params = this.cache.getData('mobParams');
      // взять параметры из сервиса
      // const durationParam = params && parseInt(params['AE_MobParam Toast Duration'],10);
      const durationParam = NaN;
      if (isNaN(durationParam)) {
        duration = Constants.TOASTR_DURATION;
      } else {
        duration = durationParam;
        this.toastDuration = durationParam;
      }
    }
    this.toastCtrl.create({
      message: options.message,
      duration: options.duration ? options.duration : duration,
      position: options.position ? options.position : 'bottom',
      keyboardClose: options.keyboardClose !== undefined ? options.keyboardClose : true,
      cssClass: 'toast-button-cstm',
      buttons: [{
        side: 'end',
        text: 'X',
        role: 'cancel',
        handler: () => {}
      }]
    }).then((obj) => {
      obj.present();
    });
  }

  public showOnceToast(options: ToastOptions) {
    this.toastCtrl.dismiss().then((obj) => {})
      .catch(() => {})
      .finally(() => {
        this.showToast(options);
      });
  }
}
